import { Socket, Storage, Http } from "@/common/ts/index";

// 现在在业务代码中链接ws Header-new
const $socket = new Socket();

const $storage = new Storage();
const $http = new Http();

let tool = {
    methods: {
        // 向下截取指定小数位
        formatDecimal(num, decimal) {
            num = num.toString()
            let index = num.indexOf('.')
            if (index !== -1) {
                num = num.substring(0, decimal + index + 1)
            } else {
                num = num.substring(0)
            }
            return parseFloat(num).toFixed(decimal)
        },
        /** 
         * 大额数字展示数据截取逻辑
         * 大于等于10亿用B
         * 大于等于100万，且不足10亿用M
         * 大于等于1千，且不足100万的数值用K
         * 数值小于1千不进行缩写
        */
        formatLargeNumber(originNumber) {
            if (!originNumber) return '--'
            let n = ''
            originNumber = Number(originNumber)
            switch (true) {
                case originNumber >= 1000000000:
                    n = Math.floor((originNumber / 1000000000) * 1000) / 1000 + 'B'
                    break
                case originNumber >= 1000000:
                    n = Math.floor((originNumber / 1000000) * 1000) / 1000 + 'M'
                    break
                case originNumber >= 1000:
                    n = Math.floor((originNumber / 1000) * 1000) / 1000 + 'K'
                    // n = Number(originNumber/1000).toFixed(3) + 'K' //千位截取不需要补零
                    break
                default:
                    // n = Math.floor(originNumber * 1000) / 1000
                    // n = this.formatDecimal(n, 3)
                    n = originNumber 
                    break
            }
            // console.log('formatLargeNumber =>', originNumber, n)
            return n
        },
        //stroage同步版本
        setStorageSync: $storage.setStorageSync.bind($storage),
        getStorageSync: $storage.getStorageSync.bind($storage),
        removeStorageSync: $storage.removeStorageSync.bind($storage),
        clearStorageSync: $storage.clearStorageSync.bind($storage),

        //storage异步版本
        setStorage: $storage.setStorage.bind($storage),
        getStorage: $storage.getStorage.bind($storage),
        removeStorage: $storage.removeStorage.bind($storage),
        clearStorage: $storage.clearStorage.bind($storage),

        //request
        post() {
            return $http.post({
                url: arguments[0],
                data: arguments[1],
                config: arguments[2]
            });
        },
        get() {
            return $http.get({
                url: arguments[0],
                data: arguments[1],
                config: arguments[2]
            });
        },
        delete() {
            return $http.delete({
                url: arguments[0],
                data: arguments[1],
                config: arguments[2]
            });
        },
        proxyGet() {
            return $http.proxyGet({
                url: arguments[0],
                data: arguments[1],
                config: arguments[2]
            });
        },
        proxyPost() {
            return $http.proxyPost({
                url: arguments[0],
                data: arguments[1],
                config: arguments[2]
            });
        },

        //socket
        wsOn: $socket.on.bind($socket),
        wsOff: $socket.off.bind($socket),
        wsSend: $socket.send.bind($socket),
        getWS() {
            return $socket
        },

        //cookie
        setCookie: window.$cookies.set,
        getCookie: window.$cookies.get,
        removeCookie: window.$cookies.remove,
        hasCookie: window.$cookies.isKey,
        keys: window.$cookies.keys
    }
};

export default tool;



// WEBPACK FOOTER //
// ./src/mixins/tool.mixin.js